(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["authority"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.authority__carousel').forEach(function (carousel) {
    var track = carousel.querySelector('[data-authority-track]');
    var prevButton = carousel.querySelector('[data-authority-prev]');
    var nextButton = carousel.querySelector('[data-authority-next]');
    if (!track) return;

    function scrollByCard(direction) {
      var card = track.querySelector('[data-authority-card]');
      var amount = card ? card.getBoundingClientRect().width + 20 : 300;
      track.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    if (prevButton) prevButton.addEventListener('click', function () { scrollByCard(-1); });
    if (nextButton) nextButton.addEventListener('click', function () { scrollByCard(1); });
  });

  document.querySelectorAll('[data-authority-card]').forEach(function (card) {
    card.addEventListener('click', function (event) {
      if (event.target.closest('.authority-card__cta')) return;
      if (event.target.closest('[data-authority-play]')) return;

      var isRevealed = card.classList.contains('is-revealed');

      document.querySelectorAll('[data-authority-card].is-revealed').forEach(function (openCard) {
        if (openCard !== card) openCard.classList.remove('is-revealed');
      });

      card.classList.toggle('is-revealed', !isRevealed);
    });
  });

  var authorityVideos = document.querySelectorAll('[data-authority-video]');

  document.querySelectorAll('[data-authority-play]').forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.stopPropagation();

      var card = button.closest('[data-authority-card]');
      var video = card.querySelector('[data-authority-video]');
      if (!video) return;

      authorityVideos.forEach(function (other) {
        if (other !== video) {
          other.pause();
          var otherCard = other.closest('[data-authority-card]');
          if (otherCard) otherCard.classList.remove('is-playing');
        }
      });

      video.play();
      card.classList.add('is-playing');
    });
  });

  authorityVideos.forEach(function (video) {
    video.addEventListener('pause', function () {
      var card = video.closest('[data-authority-card]');
      if (card) card.classList.remove('is-playing');
    });
    video.addEventListener('ended', function () {
      var card = video.closest('[data-authority-card]');
      if (card) card.classList.remove('is-playing');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-faq-split"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.faq-split__list').forEach(function (list) {
    var items = list.querySelectorAll('.faq-split__item');

    items.forEach(function (item) {
      var question = item.querySelector('.faq-split__question');

      question.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        items.forEach(function (i) {
          i.classList.remove('is-open');
          i.querySelector('.faq-split__question').setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          item.classList.add('is-open');
          question.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-tab"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.faq').forEach(function (faq) {
    var tabs = faq.querySelectorAll('.faq__tab');
    var items = faq.querySelectorAll('.faq__item');
    var questions = faq.querySelectorAll('.faq__question');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var index = tab.getAttribute('data-tab-index');

        tabs.forEach(function (item) {
          var isActive = item === tab;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive);
        });

        items.forEach(function (item) {
          item.classList.toggle('is-hidden', item.getAttribute('data-tab-group') !== index);
          item.classList.remove('is-open');
          item.querySelector('.faq__question').setAttribute('aria-expanded', 'false');
        });
      });
    });

    questions.forEach(function (question) {
      question.addEventListener('click', function () {
        var item = question.closest('.faq__item');
        var isOpen = item.classList.contains('is-open');

        items.forEach(function (i) {
          i.classList.remove('is-open');
          i.querySelector('.faq__question').setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          item.classList.add('is-open');
          question.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspot-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function closeItem(item) {
      var trigger = item.querySelector('.hs-trigger');
      var body = item.querySelector('.hs-body');
      item.classList.remove('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (body) body.style.maxHeight = '0px';
    }

    function openItem(item) {
      var trigger = item.querySelector('.hs-trigger');
      var body = item.querySelector('.hs-body');
      item.classList.add('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (body) body.style.maxHeight = body.scrollHeight + 'px';
    }

    function initHotspotSection(root) {
      if (root.getAttribute('data-hs-initialized') === 'true') return;
      root.setAttribute('data-hs-initialized', 'true');

      var items = Array.prototype.slice.call(root.querySelectorAll('.hs-item'));
      var imageCard = root.querySelector('.hs-image-card');
      var defaultSlide = imageCard ? imageCard.querySelector('[data-hs-slide="default"]') : null;
      var itemSlides = imageCard
        ? Array.prototype.slice.call(imageCard.querySelectorAll('[data-hs-slide]')).filter(function (s) {
            return s.getAttribute('data-hs-slide') !== 'default';
          })
        : [];
      var overlayPanels = imageCard ? Array.prototype.slice.call(imageCard.querySelectorAll('.hs-overlay-panel')) : [];
      var prevArrow = imageCard ? imageCard.querySelector('.hs-arrow--prev') : null;
      var nextArrow = imageCard ? imageCard.querySelector('.hs-arrow--next') : null;
      var currentIndex = null;

      function equalizeItemWidths() {
        var closedItems = items.filter(function (item) {
          return !item.classList.contains('is-open');
        });
        if (!closedItems.length) return;

        closedItems.forEach(function (item) {
          item.style.width = '';
        });

        var maxWidth = 0;
        closedItems.forEach(function (item) {
          var width = item.getBoundingClientRect().width;
          if (width > maxWidth) maxWidth = width;
        });

        closedItems.forEach(function (item) {
          item.style.width = maxWidth + 'px';
        });
      }

      function showDefaultImage() {
        itemSlides.forEach(function (s) {
          s.classList.remove('is-active');
        });
        if (defaultSlide) defaultSlide.classList.add('is-active');
      }

      function showImageAt(index) {
        if (defaultSlide) defaultSlide.classList.remove('is-active');
        itemSlides.forEach(function (s) {
          s.classList.toggle('is-active', s.getAttribute('data-hs-slide') === String(index));
        });
      }

      function showOverlayAt(index) {
        overlayPanels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-hs-overlay') === String(index));
        });
      }

      function hideOverlay() {
        overlayPanels.forEach(function (p) {
          p.classList.remove('is-active');
        });
      }

      function activate(index) {
        currentIndex = index;
        items.forEach(closeItem);
        openItem(items[index]);
        showImageAt(index);
        showOverlayAt(index);
      }

      function deactivate() {
        currentIndex = null;
        items.forEach(closeItem);
        showDefaultImage();
        hideOverlay();
      }

      items.forEach(function (item) {
        var trigger = item.querySelector('.hs-trigger');
        if (!trigger) return;

        trigger.addEventListener('click', function () {
          var index = parseInt(item.getAttribute('data-hs-index'), 10);

          if (currentIndex === index) {
            deactivate();
          } else {
            activate(index);
            if (item.scrollIntoView) {
              item.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
            }
          }
        });
      });

      if (prevArrow) {
        prevArrow.addEventListener('click', function () {
          var index = currentIndex === null ? items.length - 1 : (currentIndex - 1 + items.length) % items.length;
          activate(index);
        });
      }

      if (nextArrow) {
        nextArrow.addEventListener('click', function () {
          var index = currentIndex === null ? 0 : (currentIndex + 1) % items.length;
          activate(index);
        });
      }

      equalizeItemWidths();
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(equalizeItemWidths);
      }

      var resizeTimeout;
      window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimeout);
        resizeTimeout = window.setTimeout(function () {
          equalizeItemWidths();

          var openItem = root.querySelector('.hs-item.is-open');
          if (!openItem) return;
          var body = openItem.querySelector('.hs-body');
          if (body) body.style.maxHeight = body.scrollHeight + 'px';
        }, 150);
      });
    }

    function initAll(scope) {
      var scopeEl = scope || document;
      var sections = scopeEl.querySelectorAll ? scopeEl.querySelectorAll('.hs-section') : [];
      Array.prototype.slice.call(sections).forEach(function (section) {
        initHotspotSection(section);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["process-timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTimeline(root) {
      var blocks = root.querySelectorAll('[data-pt-block]');
      var stickyImages = root.querySelectorAll('[data-pt-sticky-image]');
      var lineFill = root.querySelector('[data-pt-line-fill]');
      var blocksContainer = root.querySelector('.process-timeline__blocks');

      if (!blocks.length) return;

      function setActive(index) {
        blocks.forEach(function (block, i) {
          block.classList.toggle('is-active', i === index);
        });

        stickyImages.forEach(function (image) {
          var imageIndex = parseInt(image.getAttribute('data-block-index'), 10);
          image.classList.toggle('is-active', imageIndex === index);
        });

        if (lineFill && blocksContainer) {
          var activeBlock = blocks[index];
          var containerRect = blocksContainer.getBoundingClientRect();
          var blockRect = activeBlock.getBoundingClientRect();
          var targetHeight = blockRect.top - containerRect.top + blockRect.height;
          lineFill.style.height = Math.max(0, targetHeight) + 'px';
        }
      }

      if (!('IntersectionObserver' in window) || window.matchMedia('(max-width: 749px)').matches) {
        setActive(0);
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var index = parseInt(entry.target.getAttribute('data-block-index'), 10);
              setActive(index);
            }
          });
        },
        {
          root: null,
          rootMargin: '-45% 0px -45% 0px',
          threshold: 0,
        }
      );

      blocks.forEach(function (block) {
        observer.observe(block);
      });

      setActive(0);

      var mql = window.matchMedia('(max-width: 749px)');
      var handleBreakpointChange = function () {
        if (!mql.matches) {
          setActive(0);
        }
      };
      if (mql.addEventListener) {
        mql.addEventListener('change', handleBreakpointChange);
      }

      var resizeTimeout;
      window.addEventListener(
        'resize',
        function () {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(function () {
            var currentActive = root.querySelector('[data-pt-block].is-active');
            if (currentActive) {
              setActive(parseInt(currentActive.getAttribute('data-block-index'), 10));
            }
          }, 200);
        },
        { passive: true }
      );
    }

    function init(root) {
      var scope = root || document;
      var sections = scope.querySelectorAll('[data-process-timeline]');
      sections.forEach(initTimeline);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scorable-expand-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var GSAP_URL = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js';
    var SCROLLTRIGGER_URL = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js';
    var initializedStages = new WeakSet();

    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var existing = document.querySelector('script[src="' + src + '"]');
        if (existing) {
          existing.addEventListener('load', resolve);
          if (existing.getAttribute('data-loaded') === 'true') resolve();
          return;
        }
        var script = document.createElement('script');
        script.src = src;
        script.onload = function () {
          script.setAttribute('data-loaded', 'true');
          resolve();
        };
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }

    function ensureGsap() {
      var tasks = [];
      if (!window.gsap) {
        tasks.push(loadScript(GSAP_URL));
      }
      return Promise.all(tasks).then(function () {
        if (!window.ScrollTrigger) {
          return loadScript(SCROLLTRIGGER_URL);
        }
      });
    }

    function initScrollVideo(stage) {
      if (initializedStages.has(stage)) return;

      var enableAnimation = stage.getAttribute('data-enable-animation') === 'true';
      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!enableAnimation || prefersReducedMotion) {
        return;
      }

      var container = stage.querySelector('[data-scroll-video-container]');
      var media = stage.querySelectorAll('[data-scroll-video-media]');

      if (!container || !media.length) return;

      var initialWidth = parseFloat(stage.getAttribute('data-initial-width')) || 92;
      var initialRadius = parseFloat(stage.getAttribute('data-initial-radius')) || 24;
      var zoomScale = (parseFloat(stage.getAttribute('data-zoom-scale')) || 115) / 100;
      var scrollDistancePercent = parseFloat(stage.getAttribute('data-scroll-distance')) || 100;
      var scrollDistancePx = window.innerHeight * (scrollDistancePercent / 100);
      var animationSpeed = (parseFloat(stage.getAttribute('data-animation-speed')) || 5) / 10;

      gsap.set(container, { width: initialWidth + '%', borderRadius: initialRadius + 'px' });
      gsap.set(media, { scale: 1 });

      var timeline = gsap.timeline({
        scrollTrigger: {
          trigger: stage,
          start: 'top 75%',
          end: '+=' + scrollDistancePx,
          scrub: animationSpeed,
          invalidateOnRefresh: true,
        },
      });

      timeline
        .to(container, { width: '100%', borderRadius: 0, ease: 'none' }, 0)
        .to(media, { scale: zoomScale, ease: 'none' }, 0);

      initializedStages.add(stage);
    }

    function init(root) {
      var scope = root || document;
      var stages = scope.querySelectorAll('[data-scroll-video]');
      if (!stages.length) return;

      ensureGsap().then(function () {
        gsap.registerPlugin(ScrollTrigger);
        stages.forEach(initScrollVideo);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-text-reveal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var GSAP_URL = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js';
    var SCROLLTRIGGER_URL = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js';
    var initializedRoots = new WeakSet();

    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var existing = document.querySelector('script[src="' + src + '"]');
        if (existing) {
          if (existing.getAttribute('data-loaded') === 'true') {
            resolve();
          } else {
            existing.addEventListener('load', resolve);
          }
          return;
        }
        var script = document.createElement('script');
        script.src = src;
        script.onload = function () {
          script.setAttribute('data-loaded', 'true');
          resolve();
        };
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }

    function ensureGsap() {
      var tasks = [];
      if (!window.gsap) {
        tasks.push(loadScript(GSAP_URL));
      }
      return Promise.all(tasks).then(function () {
        if (!window.ScrollTrigger) {
          return loadScript(SCROLLTRIGGER_URL);
        }
      });
    }

    function getRevealOrder(count, direction) {
      var indices = [];
      for (var i = 0; i < count; i++) {
        indices.push(i);
      }

      if (direction === 'right-to-left') {
        indices.reverse();
      } else if (direction === 'center-out') {
        var center = (count - 1) / 2;
        indices.sort(function (a, b) {
          return Math.abs(a - center) - Math.abs(b - center);
        });
      }

      return indices;
    }

    function initReveal(root) {
      if (initializedRoots.has(root)) return;

      var words = root.querySelectorAll('[data-reveal-word]');
      if (!words.length) return;

      var direction = root.getAttribute('data-reveal-direction') || 'left-to-right';
      var animationSpeed = (parseFloat(root.getAttribute('data-animation-speed')) || 5) / 10;
      var order = getRevealOrder(words.length, direction);
      var orderedWords = order.map(function (i) {
        return words[i];
      });

      var timeline = gsap.timeline({
        scrollTrigger: {
          trigger: root,
          start: 'top 80%',
          end: 'bottom bottom',
          scrub: animationSpeed,
          invalidateOnRefresh: true,
        },
      });

      timeline.to(orderedWords, {
        opacity: 1,
        filter: 'blur(0px)',
        color: getComputedStyle(root).getPropertyValue('--sr-heading-color').trim(),
        ease: 'none',
        duration: 1.2,
        stagger: 0.5,
      });

      initializedRoots.add(root);
    }

    var refreshScheduled = false;

    function scheduleRefresh() {
      if (!window.ScrollTrigger || refreshScheduled) return;
      refreshScheduled = true;
      requestAnimationFrame(function () {
        ScrollTrigger.refresh();
        refreshScheduled = false;
      });
    }

    var globalListenersBound = false;

    function bindGlobalRefreshListeners() {
      if (globalListenersBound) return;
      globalListenersBound = true;

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(scheduleRefresh);
      }

      var resizeTimeout;
      window.addEventListener(
        'resize',
        function () {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(scheduleRefresh, 200);
        },
        { passive: true }
      );
    }

    function init(root) {
      var scope = root || document;
      var sections = scope.querySelectorAll('[data-scroll-reveal]');
      if (!sections.length) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      ensureGsap().then(function () {
        gsap.registerPlugin(ScrollTrigger);
        sections.forEach(initReveal);
        bindGlobalRefreshListeners();

        // Layout above this section (images, custom fonts, accordions in
        // other sections) can still shift page height after this point.
        // Re-measure trigger positions once things settle so the reveal
        // never starts from a stale/incorrect scroll position.
        scheduleRefresh();
      });
    }

    if (document.readyState === 'complete') {
      init();
    } else {
      window.addEventListener('load', function () {
        init();
      });
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
      scheduleRefresh();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["variant-gallery-section"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.variant-gallery').forEach(function (gallery) {
    var swatches = gallery.querySelectorAll('.variant-gallery__swatch');
    var images = gallery.querySelectorAll('.variant-gallery__image');
    var labels = gallery.querySelectorAll('.variant-gallery__swatch-label');

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var index = swatch.getAttribute('data-variant-index');
        var activeLabel = swatch.getAttribute('data-variant-label');

        swatches.forEach(function (item) {
          var isSelected = item.getAttribute('data-variant-index') === index;
          item.classList.toggle('is-selected', isSelected);
          item.setAttribute('aria-pressed', isSelected);
        });

        images.forEach(function (image) {
          image.classList.toggle('is-active', image.getAttribute('data-variant-index') === index);
        });

        labels.forEach(function (label) {
          label.textContent = activeLabel;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
